import Container from './Container';
import CreateDkimKeyPage from './CreateDkimKeyPage';
import CreateForm from './CreateForm';
import DeleteDomainSection from './DeleteDomainSection';
import DkimKeyDetailsPage from './DkimKeyDetailsPage';
import DkimKeysTab from './DkimKeysTab';
import DomainStatusSection from './DomainStatusSection';
import EditDkimKeyPage from './EditDkimKeyPage';
import LinkTrackingDomainSection from './LinkTrackingDomainSection';
import SendingAndBounceDomainSection from './SendingAndBounceDomainSection';
import SendingDomainsTab from './SendingDomainsTab';
import SendingDomainsTable from './SendingDomainsTable';
import SetupBounceDomainSection from './SetupBounceDomainSection';
import SetupForSending from './SetupForSending';
import TlsStatusBadge from './TlsStatusBadge';
import TrackingDnsSection from './TrackingDnsSection';
import TrackingDomainsTab from './TrackingDomainsTab';
import TrackingDomainsTable from './TrackingDomainsTable';
import TrackingDomainStatusCell from './TrackingDomainStatusCell';
import TrackingDomainTLSCertificateSection from './TrackingDomainTLSCertificateSection';
import VerifyEmailSection from './VerifyEmailSection';

export default {
  CreateDkimKeyPage,
  CreateForm,
  Container,
  DkimKeyDetailsPage,
  DkimKeysTab,
  EditDkimKeyPage,
  SendingDomainsTab,
  TrackingDomainsTab,
  SendingDomainsTable,
  TrackingDomainsTable,
  SetupForSending,
  SetupBounceDomainSection,
  SendingAndBounceDomainSection,
  DeleteDomainSection,
  DomainStatusSection,
  LinkTrackingDomainSection,
  VerifyEmailSection,
  TrackingDomainStatusCell,
  TrackingDnsSection,
  TrackingDomainTLSCertificateSection,
  TlsStatusBadge
};
